/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionId } from './ActionId';
/**
 * Metadata for required work that has no configured implementation.
 */
export type EmployeeExecutionMissingCapabilityBlocker = {
    /**
     * Deterministic blocker classification.
     */
    category: EmployeeExecutionMissingCapabilityBlocker.category;
    /**
     * Sanitized human-readable explanation without raw tool output.
     */
    reason: string;
    /**
     * Required capability that has no usable implementation.
     */
    capability: string;
    /**
     * Registered tools where any one could implement the missing capability.
     */
    requiredAnyOfToolNames?: Array<ActionId>;
    /**
     * ISO timestamp when the runtime determined that progress was blocked.
     */
    occurredAt: string;
};
export namespace EmployeeExecutionMissingCapabilityBlocker {
    /**
     * Deterministic blocker classification.
     */
    export enum category {
        MISSING_CAPABILITY = 'missing-capability',
    }
}

